import {
  useInfiniteQuery,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import {
  GetBanners,
  GetBlogsCarousel,
  GetCarouselById,
  GetCarousels,
  GetDoctorCarouselById,
} from './promotion';

export const useGetBanners = (
  options?: Omit<UseQueryOptions<any, Error>, 'queryKey'>,
): UseQueryResult<any, Error> => {
  return useQuery<any, Error>({
    queryKey: ['GetBanners'],
    queryFn: () => GetBanners(),
    ...options,
  });
};

export const useGetCarousels = (
  options?: Omit<UseQueryOptions<any, Error>, 'queryKey'>,
): UseQueryResult<any, Error> => {
  return useQuery<any, Error>({
    queryKey: ['GetCarousels'],
    queryFn: () => GetCarousels(),
    ...options,
  });
};

export const useGetPaginateDoctorCarousel = (
  body?: any,
  options?: Omit<UseQueryOptions<any, Error>, 'queryKey'>,
): UseQueryResult<any, Error> => {
  return useQuery<any, Error>({
    queryKey: ['GetDoctorCarouselById', body],
    queryFn: () => GetDoctorCarouselById(body),
    enabled: !!body?.carouselId,
    ...options,
  });
};

export const useGetDoctorCarousel = (body?: any) => {
  const {
    data,
    isLoading,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ['GetDoctorCarouselById', body],
    queryFn: ({ pageParam = 1 }) =>
      GetDoctorCarouselById({
        pageNumber: body?.pageNumber ?? pageParam,
        ...body,
      }),
    initialPageParam: 1,
    getNextPageParam: (data: any) => {
      return Math.floor(data?.totalCount / 10) + 1 === data?.pageNumber
        ? undefined
        : data?.pageNumber + 1;
    },
    enabled: !!body?.carouselId,
  });

  return {
    data,
    isLoading,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    refetch,
  };
};

export const useGetPaginateCarouselProduct = (
  body?: any,
  options?: Omit<UseQueryOptions<any, Error>, 'queryKey'>,
): UseQueryResult<any, Error> => {
  return useQuery<any, Error>({
    queryKey: ['GetCarouselById', body],
    queryFn: () => GetCarouselById(body),
    ...options,
  });
};

export const useGetCarouselProduct = (body?: any) => {
  const {
    data,
    isLoading,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ['GetCarouselById', body],
    queryFn: ({ pageParam = 1 }) =>
      GetCarouselById({
        ...body,
        pageNumber: body?.pageNumber ?? pageParam,
      }),
    initialPageParam: 1,
    getNextPageParam: (data: any) => {
      return Math.floor(data?.totalCount / 10) + 1 === data?.pageNumber
        ? undefined
        : data?.pageNumber + 1;
    },
    enabled: !!body?.carouselId,
  });

  return {
    data,
    isLoading,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    refetch,
  };
};

export const useGetBlogsCarousel = (
  options?: Omit<UseQueryOptions<any, Error>, 'queryKey'>,
): UseQueryResult<any, Error> => {
  return useQuery<any, Error>({
    queryKey: ['GetBlogsCarousel'],
    queryFn: () => GetBlogsCarousel(),
    ...options,
  });
};
